import PropTypes from 'prop-types';

export const MessagePropType = PropTypes.shape({
  message: PropTypes.string,
  createdDateTime: PropTypes.string,
  additionalCount: PropTypes.number,
});

/**
 * @typedef {object} MessagePropType
 * @property {string} message
 * @property {string} createdDateTime
 * @property {number} additionalCount
 */
